const { round } = require('lodash');

class ExpressCartItemCountController {

    constructor($scope, shopPageStateService, settings, trolleyService) {
        this.trolleyService = trolleyService;
        this.settings = settings;
        this.shopPageStateService = shopPageStateService;

        $scope.$watch(
            () => this.trolleyService.totalItemQuantity,
            () => this.updateItemCounts(),
        );
    }

    $onInit() {
        // default values
        this.remainingItems = 0;
        this.exceededItems = 0;
        this.hasExceededLimit = false;

        this.orderLimitExceededWarningError = this.settings.deliveryWindowAlerts.orderLimitExceededWarningError;
    }

    updateItemCounts() {
        this.remainingItems = round(this.trolleyService.maximumOrderQuantity - this.trolleyService.totalItemQuantity, 1);
        this.exceededItems = round(this.trolleyService.totalItemQuantity - this.trolleyService.maximumOrderQuantity, 1);
        this.hasExceededLimit = this.exceededItems > 0;

        if (this.hasExceededLimit && !this.shopPageStateService.isCartOpen) {
            this.shopPageStateService.isCartOpen = true;
        }
    }
}

const expressCartItemCountControllerComponentDefinition = {
    controller: ['$scope', 'ShopPageStateService', 'Settings', 'TrolleyService', ExpressCartItemCountController],
    template: require('./express-cart-item-count.component.html').trim(),
};

module.exports = {
    ExpressCartItemCountController,
    expressCartItemCountControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/express/express-cart-item-count.component.js